// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> rr-living-prestige -> heritage-hollow
// Generated: 2026-11-03T21:38:45.880Z
// Counts: 1 design, 28 content, 4 slot group, 1 collection binding, 6 section, 1 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "apartmentsyncsection.block": {
    "overrideType": "VALUE",
    "customValue": "realpage-oll",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.heading": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>The fees below apply to this community. Amounts shown are the most current figures on file and are subject to change. A \"—\" indicates that a fee does not apply at this property. Please note that not every fee listed applies to every resident. Some fees are optional and only apply if you choose certain services or amenities, while others apply only in specific situations, such as application screening results, lease options, late payments, or lease policy violations. Please contact the leasing office for full details and to discuss which fees may apply to your specific situation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "header.preferred_employer_title": {
    "overrideType": "VALUE",
    "customValue": "Preferred Employer Benefits",
    "generatedValue": null,
    "mappedField": null
  },
  "interioramenitieslist.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p>*Available in select apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interioramenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartment Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "petscallout.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "scheduletourform.form.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.administrative_fee": {
    "overrideType": "VALUE",
    "customValue": "$125",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.early_termination_fee": {
    "overrideType": "VALUE",
    "customValue": "2 months rent",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.intra_community_transfer_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.late_fee": {
    "overrideType": "VALUE",
    "customValue": "10%",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.month_to_month_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$250 per pet",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$25",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.risk_fee": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.security_deposit": {
    "overrideType": "VALUE",
    "customValue": "Studio/1BR: $250 | 2BR: $350 | Conditional: Standard deposit + ½ month's rent or alternative program, if available.",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.short_term_rental_fee": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  },
  "floor-plans-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/fee-information"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Fee Information"
      }
    }
  },
  "specialofferbanner.specials_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": ""
      },
      "label": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.photos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_a018c494-4fab-4e9f-ae93-6abbd3a27b83",
      "custom_3c4c0e9f-a8c7-4f74-bed9-0cd578ce24f7",
      "custom_2e0bd775-d2bd-480a-bd5d-337df8d8ef16",
      "custom_e111722e-34a4-4d7b-b040-941e9fa5721b",
      "custom_cc4b1705-aac6-462e-a23c-ade7cce0ab51",
      "custom_48bdf323-36f3-4444-9ca9-90cf5e59fe75",
      "custom_11f193f0-67da-4ab8-ae3e-8245da7c20dd",
      "custom_7e459bba-2152-4bf1-8239-f160bb4c3ce6",
      "custom_5c2b03ff-d945-4b84-8df3-941c17c5a999",
      "custom_0cddc14c-511e-40f1-9970-d0c8d934d075",
      "custom_39079a99-916f-420c-99eb-b4d07c7da4b5"
    ],
    "hiddenIndices": null,
    "ordering": [
      0,
      2,
      1,
      3,
      6,
      8,
      4,
      5,
      7,
      11,
      9,
      10
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.block:realpage-oll": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  }
};
